import { HeaderComponent } from './../header/header.component';
import { Component, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog } from '@angular/material/dialog';
import { CasedialogComponent } from '../casedialog/casedialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import {
  CompName,
  constantStrings,
  ROLE,
  STATUSCODESTRING,
  EventType,
} from '@shared/helpers/constants';
import { CaseHistoryData, errorResponse } from '@shared/models/user.model';
import { CasedashboardService } from '../casedashboard.service';
import { AuthService } from '@shared/services/auth.service';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { EditduedatedialogComponent } from '../editduedatedialog/editduedatedialog.component';
import { Router } from '@angular/router';
import { SharedStateService } from '@shared/services/shared-state.service';
import { ActiveCaseElement } from '../interface/active-case.interface';
import { formatDate } from '@angular/common';
import { ProjectActionsRequestService } from '@viewer/services';
import { IClaimantEditDetailsDto } from '@viewer/services/project-open-action.data'
import { AlertDialogAnswer, AlertDialogResults } from '@shared/alert-dialog/alert-dialog.data';
import { AlertDialogService } from '@shared/alert-dialog';
import { parse, differenceInDays, differenceInHours, differenceInMinutes, differenceInMilliseconds, addMinutes } from 'date-fns';
import { environment } from '@environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-active-case',
  templateUrl: './active-case.component.html',
  styleUrls: ['./active-case.component.scss'],
})
export class ActiveCaseComponent implements OnInit {
  private subscription: Subscription;
  displayedColumns: string[] = [
    'icons',
    'caseId',
    'anatomy',
    'imagingType',
    'caseStatus',
    'createDateTime',
    'dueDateTime',
    'timeDifference',
    'actionsClaim',
  ];
  dataSource = new MatTableDataSource<ActiveCaseElement>();
  selection = new SelectionModel<any>(false, []);
  public showCaseModal: boolean = false;
  public loggedInUser: string | undefined;
  isDisabled: boolean | undefined;
  statusNew = STATUSCODESTRING.statusNew;
  statusOverdue = STATUSCODESTRING.statusOverdue;
  statusUnclaimed = STATUSCODESTRING.statusUnclaimed;
  statusOverdueUnclaimed = STATUSCODESTRING.statusOverdueUnclaimed;
  statusOverdueNewUnclaimed = STATUSCODESTRING.statusOverdueNewUnclaimed;
  statusNewUnclaimed = STATUSCODESTRING.statusNewUnclaimed;
  statusInReview = STATUSCODESTRING.statusInReview;
  pagelimit: number;
  activeCaseData: CaseHistoryData;
  displaySpinner: boolean = true;
  caseCount: number;
  totalRec: number = 0;
  caseId: string;
  caseStatus: string;
  selectedRowIndex: string;
  searchText: string = '';
  activeCaseDetailsRes: any;
  userInfo: any;
  storeActiveCaseData: any;
  totalPages: number;
  errUserDetails: string;
  actionActivityDetails: string;
  updateCaseDetailsRes: string;
  days: number;
  hours: number;
  minutes: number;
  caseStatusDisplayFlag: boolean = false;
  reviewerFlag: boolean = false;
  managerFlag: boolean = false;
  loggedInUserRole: string;
  editDueDateRes = {};
  editingEle: any;
  editDialogFlag: boolean = false;
  auditAction: any;
  errorRes: errorResponse;
  expandTable: boolean = false;
  errOutcome: number = 0;
  successOutcome: number = 1;
  eventOutcome: number;
  eventType: string;
  sysException: string;
  compName: string = CompName.ACTIVE;
  utcTime = new Date().getTimezoneOffset() * 60000;
  apiCurDtTimeUTC: string;
  sortBy: string;
  sortOrder: SortDirection;
  currentDueDate: any;
  //pageNumberTemp:any;
  pageNumberTemp = 1;
  uploadId: any;
  auditText: string | number;
  disableHilIntegrity: any

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private casedashboardService: CasedashboardService,
    private authService: AuthService,
    private router: Router,
    private sharedState: SharedStateService,
    private _projectActionsRequestService: ProjectActionsRequestService,
    private alertDialogService: AlertDialogService,
    private sanitizer: DomSanitizer
  ) { }

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(HeaderComponent) filterBanner;

  ngOnInit(): void {
    //converting current Date and time to UTC date and Time
    let curDtTimeUTC = new Date().getTime() + this.utcTime;
    this.apiCurDtTimeUTC = formatDate(
      curDtTimeUTC,
      'MM/dd/yyyy HH:mm:ss',
      'en-US'
    );
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe((response) => {
      this.auditAction = response;
    });
    const idToken = this.authService.getCognitoIdTokenFromStorage();
    const decodedValue = this.authService.decode(idToken);
    this.loggedInUserRole = decodedValue
      ? decodedValue['cognito:groups'][0]
      : '';

    this.loggedInUser = decodedValue ? (decodedValue['cognito_old_username']?decodedValue['cognito_old_username']:decodedValue['cognito:username']) : '';;
    if (this.loggedInUserRole == ROLE.SNN_HIL_MANAGER) {
      this.managerFlag = true;
    } else if (this.loggedInUserRole == ROLE.SNN_HIL_REVIEWER) {
      this.reviewerFlag = true;
    }

    this.pagelimit = constantStrings.PageLimit;
    this.activeCaseData = {
      page: 0,
      limit: this.pagelimit,
      column: 'dueDate',
      sortOrder: 'ASC',
      searchText: '',
      anatomy: [],
      sourceFacilityId: [],
      caseStatus: [9, 14, 15, 16],
      claimantUserName: [],
      imagingType: [],
      fromDueDate: null,
      toDueDate: null,
      fromUpdatedDate: null,
      toUpdatedDate: null,
    };
    this.totalRec = 0;
    this.getActiveCaseDetails(this.activeCaseData);
    this.subscription = interval(1000).subscribe((x) => {
      this.calculateTimeUntilDue(true);
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = null;
  }

  ngAfterViewChecked() {
    if (this.filterBanner.filterActive) {
      this.expandTable = true;
    } else {
      this.expandTable = false;
    }
  }
  /**
   * The function announces the sorting state of a table using the Angular LiveAnnouncer.
   * @param {Sort} sortState - Sort object that contains information about the current sorting state,
   * including the sorting direction.
   */
  sortTable(sortState: Sort) {
    this.sortBy = sortState.active;
    this.sortOrder = sortState.direction;
    this.activeCaseData.column = sortState.active;
    this.activeCaseData.sortOrder = sortState.direction;
    const columnNameDB = {
      'caseStatus': 'claimantFirstName', 'createDateTime': 'createdDate',
      'dueDateTime': 'dueDate', 'timeDifference': 'dueDate'
    }
    if (sortState.active === 'timeDifference' && sortState.direction === 'asc') {
      this.activeCaseData.sortOrder = 'desc'
    } else if (sortState.active === 'timeDifference' && sortState.direction === 'desc') {
      this.activeCaseData.sortOrder = 'asc'
    }
    this.activeCaseData.column = columnNameDB[sortState.active];
    //  this.activeCaseData.page= this.activeCaseData.page + 1;
    //  this.activeCaseData.limit= (this.activeCaseData.page + 1) * 25
    // this.activeCaseData.page = 0;
    this.getActiveCaseDetails(this.activeCaseData);
  }
  /**
   * The function opens a dialog box to display case details and waits for the dialog to close.
   */
  viewCaseDetails(rowData): void {
    let dialogRef = this.dialog.open(CasedialogComponent, {
      autoFocus: false,
      id: 'caseDetails',
      disableClose: true,
      data: {
        id: rowData.caseId,
        status: rowData.caseStatus,
        faciltyId: rowData.sourceFacilityId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
  public convertStringToInt(hour: string) {
    return parseInt(hour);
  }
  public OnClaimClick(rowData, action) {
    if (
      rowData.caseStatus === STATUSCODESTRING.statusNew ||
      rowData.caseStatus === STATUSCODESTRING.statusUnclaimed ||
      rowData.caseStatus === STATUSCODESTRING.statusOverdueNewUnclaimed ||
      rowData.caseStatus === STATUSCODESTRING.statusOverdueUnclaimed
    ) {
      this.checkEditPermission(rowData, action);
    } else {
      this.updateCaseDetails(rowData);
      this.showAlert(rowData);
    }

  }
  isDisable() {
    this.isDisabled = true;
  }
  /**
   * This function retrieves active case details from a service and updates the data source accordingly,
   * while also calculating and sorting based on certain criteria.
   */
  getActiveCaseDetails(params : any) {
    this.displaySpinner = true;
    //check if the search String contains New , unclaimed or Overdue Text, then modify the request accordingly
    if (this.searchText && this.searchText != '') {
      if (this.statusNew.includes(this.searchText.toUpperCase())) {
        this.activeCaseData.caseStatus = [15];
        this.activeCaseData.searchText = '';
      } else if (this.statusUnclaimed.includes(this.searchText.toUpperCase())) {
        this.activeCaseData.caseStatus = [14];
      } else if (this.statusOverdue.includes(this.searchText.toUpperCase())) {
        this.activeCaseData.fromDueDate = constantStrings.startTimeDue;
        this.activeCaseData.toDueDate = this.apiCurDtTimeUTC;
        this.activeCaseData.searchText = '';
      }
    }
    params.page = 0;
    this.casedashboardService.getCaseDashboardDetails(params).subscribe({
      next: (Response) => {
        let result = Response;
        this.displaySpinner = false;
        this.caseCount = 0;
        this.totalRec = 0;
        this.activeCaseDetailsRes = result;
        this.totalPages = result.totalPages;
        if (this.activeCaseData.page == 0) {
          this.storeActiveCaseData = result.dashboardDetails;
        } else {
          this.storeActiveCaseData = [
            ...this.storeActiveCaseData,
            ...result.dashboardDetails,
          ];
        }
        this.dataSource.data = this.storeActiveCaseData;
        this.calculateTimeUntilDue(false);

        if (
          result.dashboardDetails != null &&
          result.dashboardDetails.length &&
          this.dataSource.data.length > 0
        ) {
          this.totalRec = this.storeActiveCaseData.length;
          this.caseCount = this.totalRec;
        }
      },
      error: (error) => {
        this.errorRes = error;
        this.displaySpinner = false;
      },
    });
  }
  /**
   * This function updates case details and makes an API call to update the case status, due date, and
   * other information.
   */
  updateCaseDetails(params) {
    let caseStatusCode, cUserName, cUserFirstName, cUserLastName, actionName;
    this.activeCaseData.page = 0;
    if (
      params.caseStatus === STATUSCODESTRING.statusNew ||
      params.caseStatus === STATUSCODESTRING.statusUnclaimed ||
      params.caseStatus === STATUSCODESTRING.statusOverdueNewUnclaimed ||
      params.caseStatus === STATUSCODESTRING.statusOverdueUnclaimed
    ) {
      caseStatusCode = 9;
      cUserName = this.casedashboardService.loggedInUserName;
      cUserFirstName = this.casedashboardService.loggedInUserFirstName;
      cUserLastName = this.casedashboardService.loggedUserLastName;
      actionName = this.auditAction.UserActions.caseClaimed;
    } else {
      caseStatusCode = 14;
      cUserName = constantStrings.NOT_APPLICABLE;
      cUserFirstName = constantStrings.NOT_APPLICABLE;
      cUserLastName = constantStrings.NOT_APPLICABLE;
      actionName = this.managerFlag
        ? this.auditAction.UserActions.caseUnassigned + params.claimantUserName
        : this.auditAction.UserActions.caseUnclaimed;
    }
    let apiParams = {
      caseId: params.caseId,
      caseStatus: caseStatusCode,
      errorNotes: '',
      claimantUserName: cUserName,
      claimantFirstName: cUserFirstName,
      claimantLastName: cUserLastName,
    };
    this.caseId = params.caseId;
    this.displaySpinner = true;
    this.casedashboardService.updateCaseDetails(apiParams).subscribe({
      next: (Response) => {
        let result = Response;
        this.displaySpinner = false;
        this.auditLogActivity(
          this.successOutcome,
          EventType.update,
          actionName
        );
        this.updateCaseDetailsRes = result;
        //removed get API call and update the same Array of Object to prevent refreshing data on screen
        for (let key of this.storeActiveCaseData) {
          if (key.caseId == params.caseId) {
            if (this.check(params.caseStatus)) {
              key['caseStatusTemp'] = this.statusInReview;
              key.claimantUserName = this.casedashboardService.loggedInUserName;
              key.claimantFirstName =
                this.casedashboardService.loggedInUserFirstName;
              key.claimantLastName =
                this.casedashboardService.loggedUserLastName;
            } else {
              key['caseStatusTemp'] = this.statusUnclaimed;
              key.claimantUserName = constantStrings.NOT_APPLICABLE;
              key.claimantFirstName = constantStrings.NOT_APPLICABLE;
              key.claimantLastName = constantStrings.NOT_APPLICABLE;
            }
          }
        }
      },
      error: (error) => {
        this.errorRes = error;
        this.auditLogActivity(
          this.errOutcome,
          EventType.update,
          this.auditAction.UserActions.sysException
        );
        this.displaySpinner = false;
      },
    });
  }
  /**
   * This function edits the due date of a case and updates the active case details.
   * @param params - An object containing the following properties:
   */
  editDueDate(params) {
    this.activeCaseData.page = 0;
    let apiParams = {
      caseId: params.caseId,
      dueDateTime: params.dueDateTime,
    };
    this.caseId = params.caseId;
    this.displaySpinner = true;
    let actionName =
      this.auditAction.UserActions.dueDateEditOld +
      this.currentDueDate +
      ' ' +
      this.auditAction.UserActions.dueDateEditNew +
      params.dueDateTime;
    this.casedashboardService.editDueDate(apiParams).subscribe({
      next: (Response) => {
        let result = Response;
        this.displaySpinner = false;
        this.auditLogActivity(
          this.successOutcome,
          EventType.update,
          actionName
        );
        this.editDueDateRes = result;
        //removed get API call and update the same Array of Object to prevent refreshing data on screen
        for (let key of this.storeActiveCaseData) {
          if (key.caseId == params.caseId) {
            if (
              key.caseStatus === this.statusNew ||
              key.caseStatus === this.statusOverdueNewUnclaimed
            ) {
              key.caseStatus = this.statusNewUnclaimed;
            } else {
              key.caseStatus = this.statusUnclaimed;
            }
            key.dueDateTime = params.dueDateTime;
            key['overDueFlag'] = false;
          }
        }
      },
      error: (error) => {
        this.errorRes = error;
        this.auditLogActivity(
          this.errOutcome,
          EventType.update,
          this.auditAction.UserActions.sysException
        );
        this.displaySpinner = false;
      },
    });
  }
  /**
   * The function increments the page number and retrieves active case details with a search text
   * parameter.
   */
  showMore() {

    this.pageNumberTemp = this.pageNumberTemp + 1;
    this.activeCaseData.limit = (this.pageNumberTemp) * 25;
    this.activeCaseData.searchText = this.searchText;
    this.getActiveCaseDetails(this.activeCaseData);
  }
  highlightRow(row) {
    this.selectedRowIndex = row.caseId;
  }
  /**
   * This function calculates the time difference between the current date and a due date for a list of
   * items and sets flags and review times based on the difference.
   */
  calculateTimeUntilDue(shouldCallApi = false) {
    if (this.storeActiveCaseData !== undefined) {
      for (let i = 0; i < this.storeActiveCaseData.length; i++) {
        const item = this.storeActiveCaseData[i];
        const dateString = item.dueDateTime;
        const parsedDate = parse(dateString, 'MM/dd/yyyy HH:mm:ss', new Date());
        const currentDate = addMinutes(new Date(), new Date().getTimezoneOffset())
        const days = differenceInDays(parsedDate, currentDate);
        const hours = differenceInHours(parsedDate, currentDate) % 24;
        const minutes = differenceInMinutes(parsedDate, currentDate) % 60;
        const timeDifference = differenceInMilliseconds(parsedDate, currentDate);
        item.timeDifference = timeDifference;
        item.overDueFlag = false;
        item.oneDayUntilDue = false;
        item.dueTimeFlag = false;
        if ([this.statusInReview, STATUSCODESTRING.statusBoneModel, STATUSCODESTRING.statusInProgress, STATUSCODESTRING.statusProcessing].includes(item.caseStatus) || item.caseStatusTemp === this.statusInReview) {
          item.caseStatus = item.claimantUserName ? `${item.claimantFirstName.toUpperCase()} ${item.claimantLastName.toUpperCase()}` : '';
        } else if (item.caseStatus === this.statusUnclaimed || item.caseStatusTemp === this.statusUnclaimed) {
          item.caseStatus = this.statusUnclaimed;
        } else if (item.caseStatus === this.statusNewUnclaimed) {
          item.caseStatus = this.statusNew;
        }
        if (days > 1) {
          item.dueTimeFlag = true;
          item.reviewTime = `${days} days`;
        } else if (days === 1) {
          item.dueTimeFlag = true;
          item.reviewTime = `${days} day`;
        } else if (hours >= 1 && hours < 24) {
          item.oneDayUntilDue = true;
          item.reviewTime = `${hours} hours`;
        } else if (minutes >= 1 && minutes < 60) {
          item.oneDayUntilDue = true;
          item.reviewTime = `${minutes} minutes`;
        } else if (days < 1) {
          item.overDueFlag = true;
          if (item.caseStatus === this.statusNew) {
            item.caseStatus = this.statusOverdueNewUnclaimed;
            if (shouldCallApi) {
              this.getActiveCaseDetails(this.activeCaseData);
              break;
            }
          } else if (item.caseStatus === this.statusUnclaimed) {
            item.caseStatus = this.statusOverdueUnclaimed;
            if (shouldCallApi) {
              this.getActiveCaseDetails(this.activeCaseData);
              break;
            }
          }
          if(days == 0){
            if(hours > -1 && minutes <= 0){
              item.reviewTime = `${minutes} minutes`;
            }
            else{
              item.reviewTime = `${hours} hours`;
            }
          } 
          else{
            item.reviewTime = `${days} days`;
          }
        }
      }
    }
  }
  
  check(caseStatus) {
    if (
      caseStatus === this.statusNew ||
      caseStatus === this.statusUnclaimed ||
      caseStatus === this.statusOverdueNewUnclaimed ||
      caseStatus === this.statusOverdueUnclaimed
    ) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * The function searches for a case status or text and updates the active case data accordingly.
   * @param txt - The parameter "txt" is a string that represents the text to be searched. It is passed
   * as an argument to the "search" function.
   */
  search(txt) {
    if (txt == '') {
      this.activeCaseData.fromDueDate = null;
      this.activeCaseData.toDueDate = null;
      this.activeCaseData.caseStatus = [9, 14, 15, 16];
    }
    this.activeCaseData.searchText = txt;
    this.searchText = txt;
    this.activeCaseData.page = 0;
    this.activeCaseData.caseStatus = [9, 14, 15, 16];
    this.getActiveCaseDetails(this.activeCaseData);
  }
  /**
   * The function updates the active case data based on the checked status of various flags and
   * retrieves the updated data.
   */
  searchIconClick(checked) {
    this.activeCaseData.page = 0;
    this.activeCaseData.caseStatus = [9, 14, 15, 16];
    this.activeCaseData.claimantUserName = [];
    this.activeCaseData.fromDueDate = null;
    this.activeCaseData.toDueDate = null;
    //check for info Icon
    if (checked.isInfoChecked != undefined && checked.isInfoChecked) {
      this.activeCaseData.caseStatus = [15, 14];
    }
    //check for Claimed by logged in user
    if (checked.isGreenFlagChecked != undefined && checked.isGreenFlagChecked) {
      this.activeCaseData.caseStatus = [9];
      this.activeCaseData.claimantUserName.push(this.loggedInUser);
    }
    //check for overdue cases
    if (checked.isRedFlagChecked != undefined && checked.isRedFlagChecked) {
      this.activeCaseData.fromDueDate = constantStrings.startTimeDue;
      this.activeCaseData.toDueDate = this.apiCurDtTimeUTC;
    }
    //check for 24hr due date
    if (checked.isDayFlagChecked != undefined && checked.isDayFlagChecked) {
      let twentyfourHours =
        new Date().getTime() + 24 * 60 * 60 * 1000 + this.utcTime;
      this.activeCaseData.fromDueDate = this.apiCurDtTimeUTC;
      this.activeCaseData.toDueDate = formatDate(
        twentyfourHours,
        'MM/dd/yyyy HH:mm:ss',
        'en-US'
      );
    }
    this.getActiveCaseDetails(this.activeCaseData);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  _unsubscribe$ = new Subject();
  /**
   * The function navigates to a patient viewer page for a specific case ID and logs an audit activity
   * with a success outcome.
   */
  async navigateMRI(event, caseid, caseStatus, sourceFacilityId) {
    //PRSEG-264: Check if Integrity Check for HIL is disabled based on SSM 
    this.disableHilIntegrity = await this.authService.getSSMValue(environment.ssmParams.DISABLE_HIL_VALIDATION);
    if (this.disableHilIntegrity.includes('true')) {
      this.navigateMRISuccess(event, caseid, caseStatus)
    } else {
      this.validateHashByCaseId(event, caseid, caseStatus, sourceFacilityId);
    }
    localStorage.setItem("caseId", caseid);
  }

  navigateMRISuccess(event, caseid, caseStatus) {

    let actionName;
    if (event == this.auditAction.UserActions.open) {
      actionName = this.auditAction.UserActions.caseEditMode;
    } else {
      actionName = this.auditAction.UserActions.caseViewMode;
    }
    if (
      caseStatus === STATUSCODESTRING.statusNew ||
      caseStatus === STATUSCODESTRING.statusUnclaimed ||
      caseStatus === STATUSCODESTRING.statusOverdueNewUnclaimed ||
      caseStatus === STATUSCODESTRING.statusOverdueUnclaimed
    ) {
      this.router.navigate([caseid, 'patientviewer']);
      this.auditLogActivity(this.successOutcome, EventType.read, actionName, caseid);
    } else {
      this._projectActionsRequestService
        .requestUpdateEditCaseDetails(caseid)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe((data: IClaimantEditDetailsDto) => {
          const checkDiffUser = data.claimantUserName != data.lastClaimantUserName;
          const checkEditcaseUser = data.claimantUserName != data.claimantSavedUserName;
          if (data.isCaseEdited === 1 && (checkDiffUser && checkEditcaseUser)) {
            this.alertDialogService.openConfirmDialog(
              'Dialog.OPEN_EDIT_CASE',
              'Dialog.RejectButtons.EXIT',
              'Dialog.ConfirmButtons.CONTINUE'
            ).pipe(takeUntil(this._unsubscribe$))
              .subscribe((res: AlertDialogAnswer) => {
                if (res.result === AlertDialogResults[1]) {
                  this._projectActionsRequestService
                    .requestUpdateEditCaseStatus(
                      caseid,
                      0,
                      data.claimantSavedUserName
                    )
                    .subscribe();
                  this.router.navigate([caseid, 'patientviewer']);
                  this.auditLogActivity(this.successOutcome, EventType.read, actionName, caseid);
                }
              });
          } else {
            this.router.navigate([caseid, 'patientviewer']);
            this.auditLogActivity(this.successOutcome, EventType.read, actionName, caseid);
          }
        });
    }
  }


  validateHashByCaseId(event, caseid, caseStatus, sourceFacilityId) {

    this._projectActionsRequestService.validateHash(caseid).subscribe(
      (res) => {
        this.uploadId = res.responseMessage.includes('200') ? null : res.responseMessage.split(":")[1];
        if (res.responseStatus.includes("200")) {
          this.navigateMRISuccess(event, caseid, caseStatus)
        }
        else {
          this.auditLogActivity(this.successOutcome, EventType.read, constantStrings.HashFailedMessage);
          this.auditLogInDUU(this.successOutcome, sourceFacilityId, constantStrings.VIEW, this.uploadId);
          this._projectActionsRequestService.requestSaveLogForCase(
            caseid,
            this.casedashboardService.loggedInUserName,
            constantStrings.HashFailedMessage,
            new Date().toISOString(),
            1,
            'UPDATE'
          ).subscribe();

          this.alertDialogService.openConfirmDialog(
            'Dialog.HASH_VERIFICATIN_FAILED',
            'Dialog.ConfirmButtons.OK'
          );
        }
      }
    )

  }
  changeDueDate(element: any) {
    this.currentDueDate = element.dueDateTime;
    let dialogRef = this.dialog.open(EditduedatedialogComponent, {
      autoFocus: false,
      id: 'editDueDateDialog',
      data: element,
      disableClose: true,
      panelClass: 'custom-dialog-container123'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        element.dueDateTime = result;
        this.editDueDate(element);
      }
    });
  }
  loadFilterData(caseData) {
    this.activeCaseData.page = 0;
    this.activeCaseData.anatomy = caseData.anatomy;
    if (caseData.caseStatus) {
      if (caseData.caseStatus.length > 0) {
        this.activeCaseData.caseStatus = caseData.caseStatus;
        if (
          this.activeCaseData.caseStatus.includes(9) &&
          !this.activeCaseData.caseStatus.includes(16)
        ) {
          this.activeCaseData.caseStatus.push(16);
        }
        if (
          !this.activeCaseData.caseStatus.includes(9) &&
          this.activeCaseData.caseStatus.includes(16)
        ) {
          this.activeCaseData.caseStatus.pop(16);
        }
      } else if (caseData.claimantUserName.length > 0) {
        this.activeCaseData.caseStatus = [9];
      } else {
        this.activeCaseData.caseStatus = [9, 14, 15, 16];
      }
    }
    this.activeCaseData.claimantUserName = caseData.claimantUserName;
    this.activeCaseData.fromDueDate = caseData.fromDueDate;
    this.activeCaseData.fromUpdatedDate = caseData.fromUpdatedDate;
    this.activeCaseData.imagingType = caseData.imagingType;
    this.activeCaseData.sourceFacilityId = caseData.sourceFacilityId;
    this.activeCaseData.toDueDate = caseData.toDueDate;
    this.activeCaseData.toUpdatedDate = caseData.toUpdatedDate;
    this.getActiveCaseDetails(this.activeCaseData);
  }
  /**
   * This function exports an audit log as a CSV file.
   * @param params - The parameters passed to the exportAuditLogAPI function. It is not specified what
   * these parameters are, but they are likely used to specify the data to be exported or other options
   * related to the export.
   */
  public exportAuditLogAPI(params): any {
    this.casedashboardService.exportAuditLogService(params).subscribe({
      next: (Response) => {
        this.auditLogActivity(
          constantStrings.AUDITLOGEXPORT,
          EventType.read,
          this.auditAction.UserActions.caseLogDownload
        );
        const blob = new Blob([Response], { type: 'text/csv;encoding:utf-8' });
        const url = window.URL.createObjectURL(blob);
        const SANITIZED_URL = this.sanitizer.sanitize(SecurityContext.URL, url) as string;
        const a = document.createElement('a');
        a.setAttribute('href', SANITIZED_URL);
        a.setAttribute('download', params + constantStrings.AUDITLOGEXPORT);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      error: (error) => {
        this.auditLogActivity(
          constantStrings.AUDITLOGEXPORT,
          EventType.read,
          this.auditAction.UserActions.sysException
        );
        this.errorRes = error;
      },
    });
  }
  public exportLog(caseId) {
    this.isDisabled = false;
    this.exportAuditLogAPI(caseId);
  }
  /**
   * This function logs an audit activity with details such as case ID, user information, date and time,
   * action, event type, and outcome.
   */
  auditLogActivity(outcome, eventName, actionName, caseId?) {
    let auditLogTime = new Date();
    this.eventOutcome = outcome;
    let action = {
      dateTime: auditLogTime,
      caseId: caseId ? caseId : this.caseId,
      userName: this.casedashboardService.loggedInUserName,
      action: actionName,
      eventOutCome: this.eventOutcome ? 1 : 0,
      eventType: eventName,
    };
    this.casedashboardService.auditLogActivity(action).subscribe({
      next: (Response) => {
        let result = Response;
        this.actionActivityDetails = result;
      },
      error: (error) => {
        this.errUserDetails = error;
      },
    });
  }
  /**
   * This function checks a case can be editable or not
   */
  checkEditPermission(rowData, action) {
    let caseId = rowData.caseId;
    this.casedashboardService.checkEditPermission(caseId, action).subscribe({
      next: (Response) => {
        let result = Response;
        for (let key of this.storeActiveCaseData) {
          if (key.caseId == caseId) {
            //disable the claim button if isEditAllowed is false or else call the updateCaseDetails
            if (result.isEditAllowed) {
              key['claimBtnDisable'] = false;
              this.updateCaseDetails(rowData);
            } else {
              key['claimBtnDisable'] = true;
            }
          }
        }
      },
      error: (error) => {
        this.errUserDetails = error;
      },
    });
  }

  showAlert(rowData) {
    this._projectActionsRequestService
      .requestUpdateEditCaseDetails(rowData.caseId)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((data: IClaimantEditDetailsDto) => {
        if (data.claimantSavedUserName.length > 0) {
          this._projectActionsRequestService
            .requestUpdateEditCaseStatus(
              rowData.caseId,
              1,
              data.claimantSavedUserName
            )
            .subscribe();
        }
      });
  }
  // /**  this function is for save audit log on duu */

  auditLogInDUU(outcome, sourceFacilityId, str, uploadId) {
    let auditLogTime = new Date();
    this.eventOutcome = outcome;

    switch (str) {
      case constantStrings.VIEW:
        this.auditText = this.auditAction.UserActions.HashFailed;
        this.uploadId = uploadId;
        break;
      default:
        this.auditText = '';
        this.uploadId = '';
        break;
    }

    let action = {
      userName: this.casedashboardService.loggedInUserName,
      action: this.auditText + '' + this.uploadId,
      eventOutCome: this.eventOutcome ? 1 : 0,
      userFacilityId: sourceFacilityId,

    };
    this.casedashboardService.auditLogInDUU(action).subscribe({
      next: (Response) => {
        let result = Response;
        this.actionActivityDetails = result;
      },
      error: (error) => {
        this.errUserDetails = error;

      },
    });
  }


}